/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, tab: NonNullable<unknown> }} Validation_Toast_SingleInputs */

const cs_validation_toast_single = /** @type {(inputs: Validation_Toast_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chybí ${i?.field} na záložce ${i?.tab}`)
};

const en_validation_toast_single = /** @type {(inputs: Validation_Toast_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Missing ${i?.field} on the ${i?.tab} tab`)
};

/**
* | output |
* | --- |
* | "Missing {field} on the {tab} tab" |
*
* @param {Validation_Toast_SingleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_toast_single = /** @type {((inputs: Validation_Toast_SingleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Toast_SingleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_toast_single(inputs)
	return cs_validation_toast_single(inputs)
});